// @/shared/components/FeatureSlot/registry.tsx
import React from "react";
import { MembershipInput } from "@/shared/components/MembershipInput";
import { CreditCardCallout } from "@/shared/components/CreditCardCallout";
import { Quote } from "@/shared/types/Quote.interface";
import { ComponentConfig } from "@/shared/types/Features";

export interface BaseFeatureComponentProps<T = Record<string, any>> {
    componentId: string;
    stepId: string;
    metadata?: T;
    quote?: Quote;
    componentConfig: ComponentConfig;
}

type ComponentRegistry = {
    [key: string]: React.FC<BaseFeatureComponentProps<any>>;
};

export const COMPONENT_REGISTRY: ComponentRegistry = {
    MembershipInput: MembershipInput,
    CreditCardCallout: CreditCardCallout
};
